<script lang="ts">
import { defineComponent } from 'vue'
import { definePageMeta } from '#imports'
import { Routes } from '~/_routes'

export default defineComponent({
  name: 'ActivityIndexPage',
  setup() {
    definePageMeta({
      middleware: (to, from) => {
        return {
          name: Routes.activity_switchings_gantt,
          params: to.params,
          query: to.query,
          hash: to.hash,
        }
      },
    })
  },
})
</script>
